// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--1B3I6","title":"_93444fe79c--title--1zIvu","layout":"_93444fe79c--layout--2JNR1"};